import { Injectable, Type } from '@angular/core';
import { LocalService } from './local';
import { SessionService } from './session';
import { STORAGE_TYPE } from './storage.enum';
import { StorageInterface } from './storage.interface';

@Injectable({ providedIn: 'root' })
export class StorageFactory {
  private static readonly storageMap = new Map<STORAGE_TYPE, Type<StorageInterface>>()
    .set(STORAGE_TYPE.LOCAL, LocalService)
    .set(STORAGE_TYPE.SESSION, SessionService);

  public static new(storageType: STORAGE_TYPE): Type<StorageInterface> {
    const storage = StorageFactory.storageMap.get(storageType);
    if (!storage) {
      throw new Error(`Storage type ${storageType} not found`);
    }
    return storage;
  }
}
